var WDN = WDN || {};

if (typeof WDN.Queue === "undefined") {
  WDN.Queue = (function () {
    var queue, isRunning, start, timer;

    var config = {
      waitTime: 350, // ms
    };

    queue = function (callback) {
      if (!isRunning) {
        start(callback);
      } else {
        clearTimeout(timer);
        start(callback);
      }
    };

    start = function (callback) {
      isRunning = true;
      timer = setTimeout(function () {
        typeof callback === "function" ? callback() : "";
        isRunning = false;
      }, config.waitTime);
    };

    return queue;
  })();
}
